import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
import { Styles } from "./styles";
import EnglishData from "../../data/green-ptu/en.json";
import RussianData from "../../data/green-ptu/ru.json";
import UzbekData from "../../data/green-ptu/uz.json";
import { useLanguageDetector } from "../../hooks/useLanguageDetector";
import HelmetComponent from "../../components/helmet/HelmetComponent";
import { Icon } from "@iconify/react";
import { colors } from "../../components/common/element/elements";

const GreenPTU = () => {
  const [data] = useLanguageDetector(EnglishData, RussianData, UzbekData);

  return (
    <div className="main-wrapper green-ptu-page">
      <HelmetComponent title="Green PTU" description={""} keywords={""} />
      <BreadcrumbBox
        title={data?.title}
        image="/assets/images/green_ptu_1.webp"
      />
      <Styles>
        <section className="green-ptu">
          <Container>
            <Row>
              <Col xs="12">
                <div className="green-ptu-content">
                  <p>
                    {data?.par1.pre} <b>{data?.par1.bold}</b> {data?.par1.post}
                  </p>
                  <ul className="list-unstyled">
                    {data?.list?.map(({ pre, bold, post }, index) => (
                      <li className="d-flex mb-3 item" key={index}>
                        <div>
                          <Icon
                            icon="ph:paper-plane-right-duotone"
                            fontSize={20}
                            color={colors.bg2}
                          />
                        </div>
                        <p className="ps-3">
                          {pre} <b>{bold}</b> {post}
                        </p>
                      </li>
                    ))}
                  </ul>
                  <p>
                    {data?.par2.pre} <b>{data?.par2.bold}</b> {data?.par2.post}
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </Styles>
    </div>
  );
};

export default GreenPTU;
